export { default as IndexTableRowCheckMark } from './IndexTableRowCheckMark';
